// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smv-show {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 16px 20px 24px;
}

.smv-show__stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  width: 100%;
}

.smv-show__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.smv-show__heading {
  min-width: 0;
}

.smv-show__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.smv-show__title-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #0f172a;
}

.smv-show__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
}

.smv-show__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.smv-show__btn:hover {
  background: #f8fafc;
  color: #0f172a;
}

.smv-show__card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.smv-show__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 12px 12px 0 0;
}

.smv-show__card-head h2 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.smv-show__card-head .lucide {
  color: #0284c7;
}

.smv-show__id-note {
  margin: 0;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: #64748b;
}

.smv-show__id-note span {
  font-weight: 600;
  color: #334155;
}

.smv-show__category {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.smv-show__tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 16px 20px 20px;
}

.smv-show__tile {
  min-width: 0;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.smv-show__tile.is-end,
.smv-show__mini-box.is-end {
  text-align: end;
}

.smv-show__label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.smv-show__label.is-origin {
  color: #0284c7;
}

.smv-show__label.is-destination {
  color: #10b981;
}

.smv-show__value {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  color: #0f172a;
  overflow-wrap: anywhere;
}

.smv-show__value.is-id,
.smv-show__value.is-total {
  color: #0284c7;
  font-variant-numeric: tabular-nums;
}

.smv-show__value.is-total {
  font-size: 16px;
}

.smv-show__value.is-money {
  font-variant-numeric: tabular-nums;
}

.smv-show__value.is-type {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.smv-show__value.is-type .lucide {
  margin-top: 2px;
  color: #0284c7;
  flex-shrink: 0;
}

.smv-show__split {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(280px, 0.85fr);
  gap: 16px;
  align-items: stretch;
}

.smv-show__product {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px 12px;
}

.smv-show__product-name {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.smv-show__product-meta {
  margin: 6px 0 0;
  font-size: 12px;
  color: #64748b;
}

.smv-show__product-meta span {
  color: #0f172a;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.smv-show__dot {
  margin: 0 6px;
  color: #94a3b8 !important;
  font-weight: 500 !important;
}

.smv-show__qty {
  flex-shrink: 0;
  text-align: end;
}

.smv-show__qty-value {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #10b981;
  font-variant-numeric: tabular-nums;
}

.smv-show__prices,
.smv-show__mini {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 0 20px 20px;
}

.smv-show__party {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 20px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.smv-show__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.smv-show__party-name {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.smv-show__party-sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748b;
}

.smv-show__mini-box {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.smv-show__route {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 16px 20px 20px;
}

.smv-show__hop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.smv-show__hop-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: #e0f2fe;
  color: #0284c7;
}

.smv-show__hop-qty {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
}

[dir='rtl'] .smv-show__btn .lucide,
[dir='rtl'] .smv-show__hop-icon .lucide {
  transform: scaleX(-1);
}

@media (max-width: 1100px) {
  .smv-show__header,
  .smv-show__product {
    flex-direction: column;
  }

  .smv-show__actions,
  .smv-show__qty,
  .smv-show__tile.is-end,
  .smv-show__mini-box.is-end {
    justify-content: flex-start;
    text-align: start;
  }

  .smv-show__tiles,
  .smv-show__split,
  .smv-show__prices,
  .smv-show__mini,
  .smv-show__route {
    grid-template-columns: 1fr;
  }
}

@media print {
  .smv-show__actions {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/ShowStockMovement/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;;;;IAIE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;;;;;IAKE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".smv-show {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 16px 20px 24px;\n}\n\n.smv-show__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n  width: 100%;\n}\n\n.smv-show__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.smv-show__heading {\n  min-width: 0;\n}\n\n.smv-show__title-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.smv-show__title-row h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #0f172a;\n}\n\n.smv-show__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.smv-show__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.smv-show__btn:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.smv-show__card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.smv-show__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 20px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  border-radius: 12px 12px 0 0;\n}\n\n.smv-show__card-head h2 {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.smv-show__card-head .lucide {\n  color: #0284c7;\n}\n\n.smv-show__id-note {\n  margin: 0;\n  font-size: 11px;\n  font-variant-numeric: tabular-nums;\n  color: #64748b;\n}\n\n.smv-show__id-note span {\n  font-weight: 600;\n  color: #334155;\n}\n\n.smv-show__category {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.smv-show__tiles {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  padding: 16px 20px 20px;\n}\n\n.smv-show__tile {\n  min-width: 0;\n  padding: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.smv-show__tile.is-end,\n.smv-show__mini-box.is-end {\n  text-align: end;\n}\n\n.smv-show__label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0 0 6px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.smv-show__label.is-origin {\n  color: #0284c7;\n}\n\n.smv-show__label.is-destination {\n  color: #10b981;\n}\n\n.smv-show__value {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #0f172a;\n  overflow-wrap: anywhere;\n}\n\n.smv-show__value.is-id,\n.smv-show__value.is-total {\n  color: #0284c7;\n  font-variant-numeric: tabular-nums;\n}\n\n.smv-show__value.is-total {\n  font-size: 16px;\n}\n\n.smv-show__value.is-money {\n  font-variant-numeric: tabular-nums;\n}\n\n.smv-show__value.is-type {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.smv-show__value.is-type .lucide {\n  margin-top: 2px;\n  color: #0284c7;\n  flex-shrink: 0;\n}\n\n.smv-show__split {\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(280px, 0.85fr);\n  gap: 16px;\n  align-items: stretch;\n}\n\n.smv-show__product {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 20px 12px;\n}\n\n.smv-show__product-name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.3;\n}\n\n.smv-show__product-meta {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.smv-show__product-meta span {\n  color: #0f172a;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.smv-show__dot {\n  margin: 0 6px;\n  color: #94a3b8 !important;\n  font-weight: 500 !important;\n}\n\n.smv-show__qty {\n  flex-shrink: 0;\n  text-align: end;\n}\n\n.smv-show__qty-value {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #10b981;\n  font-variant-numeric: tabular-nums;\n}\n\n.smv-show__prices,\n.smv-show__mini {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 0 20px 20px;\n}\n\n.smv-show__party {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 16px 20px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n}\n\n.smv-show__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 9999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.smv-show__party-name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.smv-show__party-sub {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.smv-show__mini-box {\n  min-width: 0;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.smv-show__route {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 140px minmax(0, 1fr);\n  gap: 12px;\n  align-items: center;\n  padding: 16px 20px 20px;\n}\n\n.smv-show__hop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n}\n\n.smv-show__hop-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 9999px;\n  background: #e0f2fe;\n  color: #0284c7;\n}\n\n.smv-show__hop-qty {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n[dir='rtl'] .smv-show__btn .lucide,\n[dir='rtl'] .smv-show__hop-icon .lucide {\n  transform: scaleX(-1);\n}\n\n@media (max-width: 1100px) {\n  .smv-show__header,\n  .smv-show__product {\n    flex-direction: column;\n  }\n\n  .smv-show__actions,\n  .smv-show__qty,\n  .smv-show__tile.is-end,\n  .smv-show__mini-box.is-end {\n    justify-content: flex-start;\n    text-align: start;\n  }\n\n  .smv-show__tiles,\n  .smv-show__split,\n  .smv-show__prices,\n  .smv-show__mini,\n  .smv-show__route {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media print {\n  .smv-show__actions {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
